/**
 * Created by ganlu on 08/11/2016.
 */
import debounce from 'lodash/debounce'

export default (Restangular) => {
    'ngInject';
    return {
        require: 'ngModel',
        link: function (scope, elem, attrs, ctrl) {
            const debounced = debounce(() => {
                const value = elem.val();
                Restangular.one('email/status').get({
                    email: value
                }).then(res => {
                    if (res.status.code === 200) {
                        ctrl.$setValidity('emailCheck', false);
                    } else {
                        ctrl.$setValidity('emailCheck', true);
                    }
                })
            }, 500)
            elem.on('input', function () {
                const value = elem.val();
                scope.$apply(() => {
                    ctrl.$setValidity('emailCheck', true);
                })
                if (!!value && !ctrl.$error.email) {
                    debounced();
                } else {
                    debounced.cancel();
                }
            });
        }
    };
}



// WEBPACK FOOTER //
// ./src/app/common/form/emailcheck.directive.js